import { addParamToTpl } from '@/utils/plugins/tpl';
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('dimensions', {
            dimensionsMode: 'mode',
        }),
        sections_hasAppliedFilters () {
            if (!this.currentFilters) {
                return false;
            }

            return !!Object.keys(this.currentFilters).filter(id => this.currentFilters[id] &&
                                                                   this.currentFilters[id].length &&
                                                                   this.currentFilters[id][0] !== undefined &&
                                                                   this.currentFilters[id][0] !== null).length;
        },
        sections_eSections () {
            let eSections = {};

            let addContextAttrs = template => {
                template = addParamToTpl(this.$root.appConfig, template, 'context-for-mobile', 'value', this.dimensionsMode !== 'l');
                template = addParamToTpl(this.$root.appConfig, template, 'context-for-desktop', 'value', this.dimensionsMode === 'l');
                template = addParamToTpl(this.$root.appConfig, template, 'context-has-filters', 'value', this.sections_hasAppliedFilters);
                template = addParamToTpl(this.$root.appConfig, template, 'context-no-filters', 'value', !this.sections_hasAppliedFilters);

                return template;
            };

            Object.keys(this.question.data.sections || {}).forEach(key => {
                eSections[key] = addContextAttrs(this.question.data.sections[key]);
            });

            return eSections;
        },
    },
};
